import { makeStyles } from "tss-react/mui";

import type { Edge } from "@atlaskit/pragmatic-drag-and-drop-hitbox/types";

const thickness = 2;

const useStyles = makeStyles()((theme) => ({
    line: {
        position: "absolute",
        zIndex: 1,
        pointerEvents: "none",
        backgroundColor: theme.palette.emteria.primary,
    },
    top: { top: -thickness / 2, left: 0, right: 0, height: thickness },
    bottom: { bottom: -thickness / 2, left: 0, right: 0, height: thickness },
    left: { left: -thickness / 2, top: 0, bottom: 0, width: thickness },
    right: { right: -thickness / 2, top: 0, bottom: 0, width: thickness },
}));

type Props = {
    edge: Edge;
};

export const DropIndicator = ({ edge }: Props) => {
    const { classes, cx } = useStyles();
    return <span aria-hidden className={cx(classes.line, classes[edge])} />;
};
